import React, { useState, useEffect } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();
// const options = [{ value: 'chocolate', label: 'Chocolate' }]
export default function AnimatedMulti(props) {
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  //  const [isUpdate, setIsUpdate] = useState(true)

  useEffect(() => {
    if (Array.isArray(props.options)) {
      setOptions(props.options);
    }
  }, [props.options]);

  useEffect(() => {
    if (Array.isArray(props.selected)) {
      // setIsUpdate(false)
      let ds = options.filter((obj) => props.selected.includes(obj.label));
      setSelected(ds);
    }
  }, [props.selected, options]);

  // useEffect(()=>{
  //     setIsUpdate(true)
  // },[isUpdate])

  // if (!isUpdate) {
  //     return null
  // } else {
  return (
    <Select
      value={selected}
      menuPlacement={props.menuPlacement ? props.menuPlacement : "bottom"}
      closeMenuOnSelect={false}
      components={animatedComponents}
      defaultValue={selected}
      isMulti
      options={options}
      onChange={props.onChange}
      placeholder={props.placeholder ? props.placeholder : "Select..."}
    />
  );
  //}
}
